import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { GradeForm } from './GradeForm';

export function AddGradeDialog({ 
  open, 
  onOpenChange, 
  sharedData, 
  setSharedData, 
  gradeForms, 
  disciplines, 
  schedules, 
  figures, 
  dances,
  updateGradeForm,
  updateGradeFormGroup,
  formatFigureDisplay,
  handleAddSubmit,
  resetAddForm,
  currentUser
}) {
  return (
    <Dialog open={open} onOpenChange={(val) => { onOpenChange(val); if (!val) resetAddForm(); }}>
      <DialogContent className="max-w-7xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>Add New Grades</DialogTitle>
        </DialogHeader>
        <form onSubmit={handleAddSubmit}>
          {/* Shared Fields - Discipline and Schedule */}
          <div className="mb-6 p-4 bg-stone-100 rounded-lg">
            <p className="text-sm text-muted-foreground mb-3">(Common to all grades)</p>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <Label>Discipline *</Label>
                <select 
                  className="w-full border rounded-lg px-3 py-2 mt-1"
                  value={sharedData.discipline_id}
                  onChange={(e) => setSharedData({...sharedData, discipline_id: e.target.value})}
                  required
                  data-testid="grade-discipline-select"
                >
                  <option value="">Select Discipline</option>
                  {disciplines.map(d => (
                    <option key={d.discipline_id} value={d.discipline_id}>{d.discipline}</option>
                  ))}
                </select>
              </div>
              <div>
                <Label>Schedule *</Label>
                <select 
                  className="w-full border rounded-lg px-3 py-2 mt-1"
                  value={sharedData.schedule_id}
                  onChange={(e) => setSharedData({...sharedData, schedule_id: e.target.value})}
                  required
                  data-testid="grade-schedule-select"
                >
                  <option value="">Select Schedule</option>
                  {schedules.map(s => (
                    <option key={s.schedule_id} value={s.schedule_id}>{s.schedule_type}</option>
                  ))}
                </select>
              </div>
            </div>
          </div>
          
          {/* Grade Forms - 2 columns side by side */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            {gradeForms.map((form, idx) => (
              <GradeForm 
                key={idx}
                form={form}
                index={idx}
                isEditMode={false}
                disciplines={disciplines}
                figures={figures}
                dances={dances}
                sharedData={sharedData}
                updateGradeForm={updateGradeForm}
                updateGradeFormGroup={updateGradeFormGroup}
                formatFigureDisplay={formatFigureDisplay}
                schedules={schedules}
                currentUser={currentUser}
              />
            ))}
          </div>
          
          <div className="mt-6 flex gap-4">
            <Button 
              type="button" 
              onClick={(e) => handleAddSubmit(e, false)} 
              className="flex-1 btn-primary" 
              data-testid="grade-save-button"
            >
              Save
            </Button>
            <Button 
              type="button" 
              onClick={(e) => handleAddSubmit(e, true)} 
              variant="outline"
              className="flex-1" 
              data-testid="grade-save-add-more-button"
            >
              Save and Add More
            </Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
}
